/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "2de5cfe3cc7045e683c5d02bf060a3fe",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "2de5cfe3cc7045e683c5d02bf060a3fe",
            "region": "us-east-1"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://3hdpefprlvhezhh63n2y3wklpq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:83b3bf46-0bfe-4881-910d-d66a27d73468",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_WlkDKSFWg",
    "aws_user_pools_web_client_id": "4pksqg0lehmee05cshh5ri18e",
    "oauth": {
        "domain": "tctpasistentepedagogf1ad6bb7-f1ad6bb7-prd.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://ap.tuclase.net/,https://admin.ummia.ai/,https://pe.ummia.ai/,https://cl.ummia.ai/,https://cl2.ummia.ai/,https://ar2.ummia.ai/,https://pe2.ummia.ai/,https://ar.ummia.ai/,https://uy.ummia.ai/",
        "redirectSignOut": "http://localhost:3000/,https://ap.tuclase.net/,https://admin.ummia.ai/,https://pe.ummia.ai/,https://cl.ummia.ai/,https://cl2.ummia.ai/,https://ar2.ummia.ai/,https://pe2.ummia.ai/,https://ar.ummia.ai/,https://ar.ummia.ai/,https://uy.ummia.ai/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
